// extracted by mini-css-extract-plugin
export var hide = "pagination-module--hide--nfxh+";
export var allHide = "pagination-module--all--hide--M+jcR";
export var smallHide = "pagination-module--small--hide--EWZwY";
export var mediumHide = "pagination-module--medium--hide--I6WJM";
export var mediumDownHide = "pagination-module--medium-down--hide--rcxYf";
export var mediumUpHide = "pagination-module--medium-up--hide--4sR7m";
export var largeHide = "pagination-module--large--hide--Ulpg3";
export var xlargeHide = "pagination-module--xlarge--hide--ApgYf";
export var xxlargeHide = "pagination-module--xxlarge--hide--0yM7l";
export var pagination = "pagination-module--pagination--5TBQ0";
export var hidden = "pagination-module--hidden--wMVZY";
export var link = "pagination-module--link--1DDOy";
export var active = "pagination-module--active--zxTFl";
export var prevNext = "pagination-module--prevNext--kFcBj";